export default function formatPercent(_value: string) {
  return `${_value}%`;
}
